import React, { useEffect, useState } from 'react'
import circleIcon from './public/Ellipse 47.svg'
import dotts from './public/Frame 36.svg'
import square from './public/Rectangle 3512.svg'
import detailArrow from './public/detailArrow.svg'
import { useNavigate } from 'react-router-dom'
import Header2 from '../header/Header2'
import { useContext } from 'react'
import { StateApp } from '../context/Context'
import Modal from "react-modal";
import axios from 'axios'
import { url } from '../url'
import Footer from '../footer/Footer'
import LoginRegister from '../Login/LoginRegister';
import jalaali from 'jalaali-js';
import { GiCarWheel } from "react-icons/gi";
import carMapic from '../TripPage/public/car-service-svgrepo-com.svg'
import SuccessLogin from '../Modal/Success Login';
import { TbLoader2 } from "react-icons/tb";
import { getSocket, SOCKET_EVENTS } from '../socket';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { IoFilterSharp } from "react-icons/io5";
import { subscribeToForegroundMessages } from '../firebase';


const PassengersTrips = () => {

    const [dropdown, setDropdown] = useState(false);

    // value for pagination scroll
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalDocs, setTotalDocs] = useState();
    const [totalPage, setTotalPage] = useState();
    const [loading, setLoading] = useState(false);
    const [moreData, setMoreData] = useState(true);

    const [allTrips, setAllTrips] = useState([]);


    const { openLogin, showSuccessLogin } = useContext(StateApp);
    const [apiError, setApiError] = useState(false);
    const [reloadAnimation, setReloadAnimation] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [apiRecall, setApiRecall] = useState(false);
    const [unavailableToken, setUnavailableToken] = useState(false);
    const [filterDropDown, setFilterDropDown] = useState(false);
    const [travelType, setTravelType] = useState("");


    const [status, setStatus] = useState("");

    let navigate = useNavigate(null);

    const tryAgain = () => {
        window.location.reload()
    }

    const [reload, setReload] = useState(false)

    useEffect(() => {
        let active = true;
        let unsubscribe = () => {};

        subscribeToForegroundMessages(() => {
            setReload(prev => !prev);
        }).then((listener) => {
            if (!active) {
                if (typeof listener === "function") listener();
                return;
            }

            unsubscribe = listener;
        }).catch((error) => {
            console.error("Foreground notification subscription failed:", error);
        });

        return () => {
            active = false;
            if (typeof unsubscribe === "function") unsubscribe();
        };
    }, []);

    // --- WebSocket: با هر تغییر وضعیت سفرها، لیست به‌روز می‌شود ---
    useEffect(() => {
        const socket = getSocket();
        if (!socket) return;

        const refreshList = () => setReload(prev => !prev);

        socket.on(SOCKET_EVENTS.TRAVEL_UPDATED, refreshList);
        socket.on(SOCKET_EVENTS.TRAVEL_ACCEPTED, refreshList);
        socket.on(SOCKET_EVENTS.TRAVEL_CANCELED, refreshList);
        socket.on(SOCKET_EVENTS.TRAVEL_COMPLETED, refreshList);

        return () => {
            socket.off(SOCKET_EVENTS.TRAVEL_UPDATED, refreshList);
            socket.off(SOCKET_EVENTS.TRAVEL_ACCEPTED, refreshList);
            socket.off(SOCKET_EVENTS.TRAVEL_CANCELED, refreshList);
            socket.off(SOCKET_EVENTS.TRAVEL_COMPLETED, refreshList);
        };
    }, []);

    useEffect(() => {
        setLoading(true)
        axios.get(`${url}/travel/v1/get-all-travels-passenger`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            },
            params: {
                status: travelType,
                limit: limit,
                page: page
            }
        }).then(res => {
            setTotalDocs(res.data.data.total_count)
            setTotalPage(res.data.data.total_pages)
            setUnavailableToken(false);
            setApiError(false)
            setLoading(false)
            setAllTrips(res.data.data.docs);

        }).catch(error => {
            if (error?.response?.status === 404) {
                setAllTrips([])
            }
            if (error?.response?.status === 401)
                setUnavailableToken(true)
            if (error?.message === "Network Error")
                setApiError(true)
            setMoreData(false);
            setLoading(false)
        })
    }, [showSuccessLogin, travelType, limit, page, reload]);

    useEffect(() => {
        setPage(1)
    }, [travelType]);

    const dateConvert = (item) => {
        const persianDate = jalaali.toJalaali(new Date(item.travel_date.slice(0, 10)).getFullYear(), new Date(item.travel_date.slice(0, 10)).getMonth() + 1, new Date(item.travel_date.slice(0, 10)).getDate())
        return `${persianDate.jy}/${persianDate.jm}/${persianDate.jd}`
    }

    const handleCancel = () => {
        setIsModalOpen(false)
    }


    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            padding: '0px',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
            borderRadius: '10px',
            outline: 'none',
            border: 'none'
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
        }
    };

    // تابع تبدیل وضعیت به رنگ و نام فارسی
    const getStatusInfo = (status) => {
        const map = {
            'payment_completed': { label: 'پرداخت شده', color: 'bg-blue-500' },
            'payment_required': { label: 'پرداخت نشده', color: 'bg-yellow-500' },
            'canceled': { label: 'لغو شده', color: 'bg-red-500' },
            'completed': { label: 'انجام شده', color: 'bg-green-500' },
            'active': { label: 'فعال', color: 'bg-cyan-500' },
            'created': { label: 'ایجاد شده', color: 'bg-gray-400' },
        };
        return map[status] || { label: status, color: 'bg-gray-400' };
    };

    return (
        <div className='mk-page mk-trips-list h-full flex flex-col min-h-[100vh] justify-between bg-grayinput'>
            <div className='md:hidden '>
                <Header2 />
            </div>
            {
                <div className=''>
                    {
                        apiError ? (
                            <div className='flex items-center justify-center py-10 px-5 h-[70vh]'>
                                <div className='flex items-center gap-5 w-full flex-col'>
                                    <div className='errorSign bg-red-600 flex items-center justify-center'>
                                        <div
                                            className='errorSign2 bg-red-100 text-red-600 text-[84px] flex items-center justify-center'>!
                                        </div>
                                    </div>
                                    <p className='text-red-600 text-center'>خطا در برقراری ارتباط! <br
                                        className='md:block hidden' /> لطفا اینترنت خود را بررسی کنید...</p>
                                    <div className={` ${reloadAnimation ? "flex items-center gap-x-2" : "invisible"}`}>
                                        <p>منتظر بمانید...</p>
                                        <TbLoader2 className={`${reloadAnimation && "animate-spin text-[25px]"}`} />
                                    </div>
                                    <button
                                        className=' text-[18px] border-2 border-darkBlue text-darkBlue hover:bg-darkBlue hover:text-white rounded-lg py-2 px-4 mt-5'
                                        onClick={tryAgain}>تلاش مجدد
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className={`flex flex-col justify-between p-5 h-full`}>
                                <div className='flex flex-col gap-y-2'>
                                    <h2 className='text-[24px] font-bold text-darkBlue'>سفر های ثبت شده</h2>
                                    <p className='text-gray-500 text-sm'>لیست تمام سفرهای شما</p>
                                </div>

                                <div
                                    className='flex flex-col gap-y-3 justify-center items-center py-2 md:my-auto border-t-2 border-gray-200 mt-5'>

                                    {/* بخش فیلترها */}
                                    <div className="flex md:flex-col min-h-9 justify-start gap-3 md:justify-center w-full my-3">
                                        <div className="flex items-center hover:cursor-pointer group" onClick={() => setDropdown(!dropdown)}>
                                            <span className="text-darkBlue font-medium">فیلتر ها</span>
                                            <IoFilterSharp className={`text-[22px] text-darkBlue transition-transform duration-300 ${dropdown ? '-rotate-90' : 'rotate-90'}`} />
                                        </div>

                                        <div className={`${dropdown ? 'flex' : 'hidden'} flex-wrap md:flex-col gap-2 md:gap-2 transition-all duration-300`}>
                                            {[
                                                { key: "", label: "همه سفر ها" },
                                                { key: "completed", label: "انجام شده" },
                                                { key: "active", label: "فعال" },
                                                { key: "payment_completed", label: "پرداخت شده" },
                                                { key: "payment_required", label: "پرداخت نشده" },
                                                { key: "created", label: "ایجاد شده" },
                                                { key: "canceled", label: "لغو شده" },
                                            ].map((filter) => (
                                                <button
                                                    key={filter.key}
                                                    className={`px-4 py-1.5 rounded-full text-sm transition-all duration-200 border-2
                                                        ${travelType === filter.key
                                                            ? 'bg-applyingbuttoncolor text-white border-applyingbuttoncolor shadow-md'
                                                            : 'bg-white text-darkBlue border-gray-300 hover:border-yellow-400 hover:bg-yellow-50'
                                                        }`}
                                                    onClick={() => setTravelType(filter.key)}
                                                    disabled={loading}
                                                >
                                                    {filter.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* لیست سفرها */}
                                    <>
                                        {!loading ?
                                            allTrips?.length > 0 ? (
                                                <>
                                                    {allTrips.map((item, index) => {
                                                        const statusInfo = getStatusInfo(item.status);
                                                        return (
                                                            <div key={index}
                                                                className='w-[96%] flex flex-col bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300'
                                                                style={{ borderRight: '5px solid #FFC400' }}
                                                            >
                                                                <div className='flex flex-col p-4'>
                                                                    {/* مبدا و تاریخ */}
                                                                    <div className='flex items-center justify-between w-full'>
                                                                        <div className='flex items-center gap-x-2'>
                                                                            <div className='w-3 h-3 border-2 border-gray-400 rounded-full'></div>
                                                                            <span className='font-medium text-gray-800'>{item?.origin_city?.name}</span>
                                                                        </div>
                                                                        <p className='text-gray-500 text-sm'>{dateConvert(item)}</p>
                                                                    </div>

                                                                    {/* خط چین */}
                                                                    <div className='mr-2 my-1'>
                                                                        <img src={dotts} alt="..." />
                                                                    </div>

                                                                    {/* مقصد و وضعیت */}
                                                                    <div className='flex items-center gap-x-2'>
                                                                        <div className='border-2 border-gray-400 rounded-sm w-3 h-3'></div>
                                                                        <div className='w-full flex items-center justify-between'>
                                                                            <span className='font-medium text-gray-800'>{item?.destination_city?.name}</span>
                                                                            <span className={`text-white text-xs px-3 py-0.5 rounded-full ${statusInfo.color}`}>
                                                                                {statusInfo.label}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* پایین کارت: قیمت و جزئیات */}
                                                                <div className='border-t border-gray-100 px-4 py-3 flex justify-between items-center'>
                                                                    <div className='flex items-baseline gap-1'>
                                                                        <span className='text-lg font-bold text-yellow-600'>{item?.price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                        <span className='text-sm text-gray-500'>تومان</span>
                                                                    </div>
                                                                    <div
                                                                        onClick={() => navigate(`/passengersTrips/${item._id}`)}
                                                                        className='flex items-center gap-2 cursor-pointer group'
                                                                    >
                                                                        <span className='text-sm font-medium text-darkBlue group-hover:text-yellow-500 transition'>جزئیات</span>
                                                                        <img width={12} src={detailArrow} alt="arrow" className="group-hover:translate-x-1 transition-transform" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}

                                                    {/* صفحه‌بندی */}
                                                    {(limit < totalDocs) && (
                                                        <div className="flex justify-center items-center gap-4 mt-6">
                                                            <button
                                                                className={`p-2 rounded-full border-2 transition-all duration-200
                                                                    ${page <= 1
                                                                        ? 'border-gray-300 text-gray-300 cursor-not-allowed'
                                                                        : 'border-darkBlue text-darkBlue hover:bg-darkBlue hover:text-white'
                                                                    }`}
                                                                onClick={() => setPage(page - 1)}
                                                                disabled={page <= 1}
                                                            >
                                                                <FaArrowRight size={14} />
                                                            </button>
                                                            <span className="text-sm font-medium text-gray-600">
                                                                صفحه {page} از {totalPage}
                                                            </span>
                                                            <button
                                                                className={`p-2 rounded-full border-2 transition-all duration-200
                                                                    ${page >= totalPage
                                                                        ? 'border-gray-300 text-gray-300 cursor-not-allowed'
                                                                        : 'border-darkBlue text-darkBlue hover:bg-darkBlue hover:text-white'
                                                                    }`}
                                                                onClick={() => setPage(page + 1)}
                                                                disabled={page >= totalPage}
                                                            >
                                                                <FaArrowLeft size={14} />
                                                            </button>
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                // حالت خالی
                                                <div className={`w-full h-[50vh] flex flex-col items-center justify-center`}>
                                                    <div className='flex flex-col items-center gap-4'>
                                                        <img src={carMapic} className="w-32 h-32 opacity-60" alt="no trips" />
                                                        <p className='text-gray-500 text-lg font-medium'>
                                                            {unavailableToken ? "شما وارد حساب کاربری نشده اید!" : "شما سفر ثبت شده‌ای ندارید!"}
                                                        </p>
                                                        <div className={`${reloadAnimation ? "flex items-center gap-2 text-gray-600" : "hidden"}`}>
                                                            <TbLoader2 className="animate-spin text-[24px]" />
                                                            <p className='text-sm'>لطفا منتظر بمانید...</p>
                                                        </div>
                                                        <div className='flex flex-col sm:flex-row gap-3 mt-4'>
                                                            <button
                                                                className='px-6 py-2 rounded-full bg-applyingbuttoncolor text-white font-medium shadow-md hover:shadow-lg transition-all duration-200'
                                                                onClick={() => unavailableToken ? setIsModalOpen(true) : tryAgain()}
                                                            >
                                                                {unavailableToken ? "ثبت نام" : "تلاش مجدد"}
                                                            </button>
                                                            <button
                                                                className='px-6 py-2 rounded-full border-2 border-darkBlue text-darkBlue font-medium hover:bg-darkBlue hover:text-white transition-all duration-200'
                                                                onClick={() => navigate("/")}
                                                            >
                                                                {unavailableToken ? "بازگشت به صفحه اصلی" : "ثبت سفر جدید"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                            :
                                            // حالت لودینگ
                                            <div className='flex items-center justify-center h-48'>
                                                <TbLoader2 className="animate-spin text-[40px] text-darkBlue" />
                                            </div>
                                        }
                                    </>
                                </div>
                            </div>
                        )
                    }
                </div>
            }
            <div>
                <Footer />
            </div>

            <Modal
                isOpen={isModalOpen}
                onRequestClose={handleCancel}
                style={customStyles}
                className="modalMobile"
            >
                <div>
                    <button className="custom-modal-close" onClick={handleCancel}>
                        &times;
                    </button>
                    {openLogin ? <LoginRegister /> : showSuccessLogin ? <SuccessLogin /> : <LoginRegister />}
                </div>
            </Modal>
        </div>
    )
}

export default PassengersTrips